import {
    ConversationInclude,
    useSaveAiConversation,
} from '@/hooks/use-ai-conversations';
import {
    ConversationRequest,
    ConversationConversationTypeEnum,
    ConversationResponse,
} from '@calm/evexia-web-sdk';
import { logger } from '@rhg/libs/logger';
import { useMutation } from '@rhg/libs/react-query';

export interface UseSaveAiConversationDataParams {
    conversationRequest: ConversationRequest;
    conversationType: ConversationConversationTypeEnum;
    onSave: (responseData: ConversationResponse) => Promise<void>;
    include?: ConversationInclude;
}

// Mutation hook for saving AI conversation data
export function useSaveAiConversationData() {
    const { saveConversationAsync } = useSaveAiConversation();

    const { mutate, mutateAsync, ...otherProps } = useMutation({
        mutationFn: async (params: UseSaveAiConversationDataParams) => {
            const { conversationRequest, conversationType, include, onSave } =
                params;

            try {
                const response = await saveConversationAsync({
                    conversationRequest,
                    conversationType,
                    ...(include && { include }),
                });
                if (response) {
                    await onSave(response.data);
                }
            } catch (error) {
                logger.error(
                    'Error saving AI conversation:',
                    {},
                    error as Error
                );
            }
        },
    });

    return {
        saveAiConversationData: mutate,
        saveAiConversationDataAsync: mutateAsync,
        ...otherProps,
    };
}
